import { EventType } from '@/models/event';

export default {
  status: {
    draft: "Vázlat",
    pending: "Függő",
    approved: "Elfogadva",
    rejected: "Elutasítva",
  },
  statusFilterLabel: 'Esemény állapota',

  actions: {
    approve: 'Elfogadás',
    reject: 'Elutasítás'
  },

  modals: {
    updatingTitle: 'Állapotok frissítése',
    disclaimer: 'Az állapotok frissítése kihatással van a készletgazdálkodásra.'
  },
  
  fields: {
    occuredAt: 'Keletkezés ideje',
    status: 'Állapot',
    patientName: 'Páciens',
    type: 'Típus',
    reason: 'Indok',
    side: 'Oldal',
    area: 'Testrész',
    comment: 'Megjegyzés',
    establishment: 'Létesístmény',
    department: 'Osztály',
    doctorName: 'Orvos Neve',
    doctorComment: 'Orvos Megjegyzése',
    complications: 'Komplikáció',
    intensity: 'Intenzitás',
    customType: 'Egyéb Tipus',
    customReason: 'Egyéb Indok',
    duration: 'Időtartam',
    hjhs: 'Hjhs',
    hjhsTotal: 'Összes Hjhs',
    physiotherapist: 'Fizióterapeuta',
    physiotherapistComment: 'Fizióterapeuta Megjegyzése',
    usedDrug: "Használt gyógyszer",
    isOnTime: "Időben történő"
  },

  // Event payload details
  values: {
    eventType: {
      [EventType.Bleeding]: 'Vérzés',
      [EventType.Injection]: 'Infúzió beadás',
      [EventType.Inspection]: 'Orvosi vizsgálat',
      [EventType.MissedInjection]: 'Kihagyott infúzió',
      [EventType.Note]: 'Jegyzet',
      [EventType.Operation]: 'Műtét',
      [EventType.Physiotherapy]: 'Gyógytorna',
      [EventType.Sport]: 'Sport',
      [EventType.Visit]: 'Látogatás',
    },
    injectionReason: {
      prophylaxis: 'Profilaxis',
      specialTreatment: 'Különleges kezelés',
      bleeding: 'Vérzés'
    },
    injectionBleedingBodyArea: {
      face: 'Arc',
      forehead: 'Homlok',
      eye: 'Szem',
      nose: 'Orr',
      ear: 'Fül',
      mouth: 'Száj',
      neck: 'Nyak',
      chest: 'Mellkas',
      belly: 'Has',
      hip: 'Derék',
      flank: 'Lágyék',
      genital: 'Ágyék',
      upper_back: 'Felhát',
      lower_back: 'Alhát',
      shoulder: 'Váll',
      upper_arm: 'Felkar',
      elbow: 'Könyök',
      forearm: 'Alkar',
      wrist: 'Csukló',
      hand: 'Kéz',
      fingers: 'Újak',
      thigh: 'Comb',
      knee: 'Térd',
      leg: 'Láb',
      ankle: 'Boka',
      sole: 'Talp',
      toes: 'Lábujj',
    },
    injectionBleedingBodySide: {
      left: 'Bal',
      right: 'Jobb',
    },
    injectionBleedingType: {
      articular: 'Ízületi',
      skin: 'Bőr',
      gums: 'Íny',
      custom: 'Egyéb'
    },
    injectionBleedingReason: {
      spontaneous: 'Spontán',
      trauma: 'Traumás',
      custom: 'Egyáb'
    },
    inspectionType: {
      hepatology: 'Hepatology',
      ortopedia: 'Ortopédia',
      virusImmunology: 'Vírus immunológia',
      custom: 'Egyéb',
    }
  }
}
